var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.bem()},[_c('nx-inline-loading',{staticClass:"loading-img",attrs:{"type":"swivel-image"}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.loadingText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }